exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".invite-manager .invites-description {\n  padding-bottom: 0;\n  padding: 0 20px;\n  color: #0d47a1; }\n\n.invite-manager .invites {\n  padding: 20px;\n  padding-top: 0; }\n  .invite-manager .invites .invite {\n    margin: 10px 0; }\n    .invite-manager .invites .invite .invite-url {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n    .invite-manager .invites .invite .revoke-invite {\n      margin: 0 12px; }\n      .invite-manager .invites .invite .revoke-invite:hover {\n        cursor: pointer; }\n\n@media (max-width: 480px) {\n  .invite-manager .invites .invite .revoke-invite {\n    margin-right: 0; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/invite_manager/invite_manager.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/invite_manager/invite_manager.scss
// module chunks = index